import { useAuthStore } from '@/stores/authStore';
import { useEffect } from 'react';

/**
 * Custom hook that provides authentication functionality
 * Wraps the Zustand auth store for easy consumption in React components
 */
export function useAuth() {
  const {
    user,
    session,
    loading,
    error,
    signUp,
    signInWithPassword,
    signInWithOAuth,
    signOut,
    resetPassword,
    updatePassword,
    updateProfile,
    clearError,
    setLoading,
    initializeAuth,
  } = useAuthStore();

  // Initialize auth on mount
  useEffect(() => {
    initializeAuth();
  }, [initializeAuth]);

  return {
    // State
    user,
    session,
    loading,
    error,
    isAuthenticated: !!user,
    
    // Actions
    signUp,
    signInWithPassword,
    signInWithOAuth,
    signOut,
    resetPassword,
    updatePassword,
    updateProfile,
    clearError,
    setLoading,
  };
}

/**
 * Hook to check if user is authenticated
 * Useful for conditional rendering
 */
export function useIsAuthenticated() {
  const { isAuthenticated } = useAuth();
  return isAuthenticated;
}

/**
 * Hook to get current user
 * Returns null if not authenticated
 */
export function useUser() {
  const { user } = useAuth();
  return user;
}
